/* Dialog Text */
import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DialogResult, DialogResultType } from "../../DialogResult";
import {UserTypes} from "../../../api/models/user-types";

export interface EditUserDialogData {
  dialogTitle: string;
  isNew: boolean;
  userName: string;
  firstName: string;
  lastName: string;
  title: string;
  termsAgreement: boolean;
  active: boolean;
  emailConfirmed: boolean;
  company: string;
  currentRole: UserTypes;
  invoiceManager: boolean;
  userManager: boolean;
}

@Component({
  selector: "edit-user-dialog",
  styleUrls: ["edit-user-dialog.component.css"],
  templateUrl: "./edit-user-dialog.component.html",
})
export class EditUserDialogComponent {
  public Result: DialogResult;

  constructor(
    public dialogRef: MatDialogRef<EditUserDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EditUserDialogData
  ) {
    this.Result = new DialogResult();
    this.Result.ResultType = DialogResultType.Cancel;
    this.Result.ResultData = null;
  }

  onCancelClick(): void {
    this.dialogRef.close(this.Result);
  }

  onConfirmClick(): void {
    this.Result.ResultType = DialogResultType.Ok;
    this.Result.ResultData = this.data;
    this.dialogRef.close(this.Result);
  }
}

/* Calling Methods */
/*
  callEditUser(params: EditUserDialogData) {
    var dialogRef = this.dialog.open(EditUserDialogComponent, {
      width: '500px',
      data: params
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result != null && result.ResultType != null && result.ResultType == DialogResultType.Ok) {
        //Do something here!
      }
    });
  }
*/
